import axios from 'axios';

import {
  IColor,
  IPaginationResponse,
  IProps,
  ICharacteristicValue
} from 'types/types';

import { getEnvironment } from 'config/environments/environment';

const getBaseUrl = () => getEnvironment().baseUrl;

class ColorsApi {
  getColorsList = async ({
    page = 1,
    paginate = true,
    perpage = 20
  }: IProps) => {
    const url = `${getBaseUrl()}/api/colors`;
    const response = await axios.get<IPaginationResponse<IColor>>(url, {
      params: { page, paginate, perpage },
      withCredentials: true
    });
    return response;
  };

  getColor = async (id: number) => {
    const url = `${getBaseUrl()}/api/colors/${id}`;
    const response = await axios.get<IColor>(url, { withCredentials: true });
    return response;
  };

  getColorValues = async (query: string) => {
    const url = `${getBaseUrl()}/api/colors/types/color/values`;
    const response = await axios.get<IPaginationResponse<ICharacteristicValue>>(
      url,
      {
        params: { search: query, perpage: 50 },
        withCredentials: true
      }
    );
    return response;
  };

  addColor = async (data: { name: string; hex_code: string }) => {
    const url = `${getBaseUrl()}/api/colors`;
    const response = await axios.post<IColor>(url, data, {
      withCredentials: true
    });
    return response;
  };

  editColor = async (id: number, data: Partial<IColor>) => {
    // Удаляем values из данных перед отправкой
    const { values, ...sendData } = data;
    const payload = {
      id,
      ...sendData
    };
    const url = `${getBaseUrl()}/api/colors/${id}`;
    const response = await axios.put<IColor>(url, payload, {
      withCredentials: true
    });
    return response;
  };

  deleteColor = async (id: number) => {
    const url = `${getBaseUrl()}/api/colors/${id}`;
    const response = await axios.delete(url, { withCredentials: true });
    return response;
  };

  updateColorsSort = async (data: Array<{ id: number; sort: number }>) => {
    const url = `${getBaseUrl()}/api/colors/sort`;
    const response = await axios.post(
      url,
      { colors: data },
      {
        withCredentials: true
      }
    );
    return response;
  };

  setColorValues = async (colorId: number, valueIds: number[]) => {
    const url = `${getBaseUrl()}/api/colors/${colorId}/values`;
    console.log('📡 Вызов setColorValues:', url, { values: valueIds }); // 🔥
    const response = await axios.post(
      url,
      { values: valueIds },
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    console.log('✅ Ответ:', response); // 🔥
    return response;
  };
}

export default new ColorsApi();
